const sum = values => values.every(value => typeof value === "number" && Number.isFinite(value))
  ? values.reduce((total, value) => total + value, 0) : null;

export function productSummaries(categories, mode, unavailable = {}) {
  const products = [
    ["Index Options — EMA Flip", "Index Options", false],
    ...(mode === "PAPER" ? [["Index Options — Trend Continuation", "Index Options", true],
      ["Index Options — NIFTY EMA21 Breakout", "Index Options", "EMA21"], ["Index Options — Hybrid AI Trading", "Index Options", "HYBRID"]] : []),
    ["Equity Options", "Equity Options"], ["Equity Intraday", "Equity Intraday"], ["Equity Swing", "Equity Swing"],
  ];
  return products.map(([name, categoryName, trend]) => {
    const category = categories.find(item => item.name === categoryName);
    const matches = row => row.mode === mode && (categoryName !== "Index Options" || (trend === "HYBRID" ? row.strategyEndpoint === "hybrid-ai" : trend === "EMA21"
      ? row.strategyEndpoint === "index-ema21" : Boolean(row.trendId) === trend && !["index-ema21", "hybrid-ai"].includes(row.strategyEndpoint)));
    const running = (category?.running || []).filter(matches);
    const today = (category?.today || []).filter(matches);
    const rows = [...new Map([...running, ...today].map(row => [row.id, row])).values()];
    const swing = categoryName === "Equity Swing";
    const unavailableSource = Boolean(unavailable[name] || unavailable[categoryName]);
    const realized = unavailableSource ? null : sum((swing ? rows : today).map(row => swing ? row.todayRealized : row.realized));
    const unrealized = unavailableSource ? null : sum(running.map(row => row.unrealized));
    const missingValues = unavailableSource ? ["Strategy data is unavailable"] : rows.flatMap(row => {
      const missing=[];
      const label=`${row.contract || row.instrument || row.id}`;
      if (swing && row.todayPnl == null) missing.push(`${label}: today's valuation P&L (previous close, current valuation or exited quantity missing)`);
      for (const client of row.clients || []) {
        const fields=[];
        if (client.realized == null) {
          const evidence=[];
          if (client.entry == null) evidence.push("entry fill");
          if (client.exit == null) evidence.push("exit fill");
          if (!(client.quantity > 0)) evidence.push("filled quantity");
          fields.push(`realized P&L; missing ${evidence.length ? evidence.join(", ") : "saved realized P&L"}`);
        }
        if (client.openQuantity > 0 && client.unrealized == null) fields.push("unrealized P&L; executable price or entry fill missing");
        if (fields.length) missing.push(`${label} / ${client.name || client.clientId}: ${fields.join("; ")}`);
      }
      if (!row.clients?.length && (row.realized == null || row.unrealized == null)) missing.push(`${label}: confirmed client fills are unavailable`);
      if (!missing.length && row.realized == null) missing.push(`${label}: realized P&L cannot be calculated; confirmed filled quantity is missing`);
      return missing;
    });
    const todayPnl = unavailableSource ? null : swing ? sum(rows.map(row => row.todayPnl)) : sum([realized, unrealized]);
    return { name, categoryName, missingValues, running: unavailableSource ? null : running.length, realized, unrealized, todayPnl,
      partial: unavailableSource || [realized, unrealized, todayPnl].includes(null) || rows.some(row => row.status === "AWAITING FILLS") };
  });
}

export function combinedSummary(products) {
  return { running: sum(products.map(row => row.running)), realized: sum(products.map(row => row.realized)),
    unrealized: sum(products.map(row => row.unrealized)), todayPnl: sum(products.map(row => row.todayPnl)),
    partial: products.some(row => row.partial) };
}
